// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles_modal__eN_Mn","center":"styles_center__rJXo2","dark":"styles_dark__P_8pR","iconClose":"styles_iconClose__tfKpq","iconWrapper":"styles_iconWrapper__FDY49"};